/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Blocked_Comp_BodyInputs */

const en_premium_blocked_comp_body = /** @type {(inputs: Premium_Blocked_Comp_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account has complimentary Premium, so there's nothing to pay for.`)
};

const es_premium_blocked_comp_body = /** @type {(inputs: Premium_Blocked_Comp_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta tiene Premium de cortesía, así que no tienes nada que pagar.`)
};

/**
* | output |
* | --- |
* | "Your account has complimentary Premium, so there's nothing to pay for." |
*
* @param {Premium_Blocked_Comp_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_blocked_comp_body = /** @type {((inputs?: Premium_Blocked_Comp_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Blocked_Comp_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_blocked_comp_body(inputs)
	return en_premium_blocked_comp_body(inputs)
});